






















import { Component, Vue } from "vue-property-decorator";
import SearchForm from "@/components/inputs/SearchForm.vue";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import CButton from "@/basics/buttons/CButton.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { USER_ALL, UserAllData } from "@/graphql/query/user/all";

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  group: {
    id: string;
    name: string;
  };
}

@Component({
  components: {
    SearchForm,
    SimpleTable,
    CButton,
    NoData
  },
  apollo: {
    users: {
      query: USER_ALL,
      update(data: UserAllData): User[] {
        return data.userFeed.users.map(user => {
          const isAdmin = !!user.scopes.find(
            s =>
              s.action === "management" &&
              s.resource === "Group" &&
              s.resourceId === user.group.id
          );
          const role = isAdmin ? "マネージャー" : "オペレーター";
          return { ...user, role };
        });
      }
    }
  }
})
export default class UsersList extends Vue {
  users: User[] = [];
}
